import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Button,
    Block,
    BlockDes,
    BlockHead,
    Icon,
    Col,
    Row,
    PreviewAltCard,
} from "../../../../components/Component";
import {
    Spinner
} from "reactstrap";
import Head from "../../../../layout/head/Head";
import OptionM from "../../../components/DynmicOption/OptionM";
import OptionC from "../../../components/DynmicOption/OptionC";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import MainReportData from "./MainReport/MainReportData";
import MainReportTotal from "./Total/MainReportTotal";
import dayjs, { Dayjs } from 'dayjs';
import ReportDataEmpParti from "./MainReport/ReportDataEmpParti";
import MainReportTotal1 from "./Total/MainReportTotal1";
import OptionL from "../../../components/DynmicOption/OptionL";
const Report1 = ({ ...props }) => {
    const [Statee, setStatee] = useState([]);
    const [transData, setTransData] = useState([]);
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 10,
        state: 0,
        generate: 0

    });
    const [generate1, setgenerate1] = useState(false);

    const [userData, setuserData] = useState([]);

    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {
            OrgId: Number(2),
            UserId: Number(localStorage.getItem("userIdA")),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardDataAdmin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //////console.log(data)
                    setData(data)
                    setStatee(data)
                    setLorder(false)

                })


    };



    const usergetdata = async () => {
        const sendData = {
            EmploymentRefId: Number(10),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetparametersNumber', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //////console.log(data)
                    setuserData(data)

                })


    };
    const [states, setstates] = useState("")
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
        setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });

    };
    const onInputChange2 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };

    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {
        usergetdata()
    }, [])


    const generate = async () => {

        getdata()
        setFormData({ ...formData, generate: formData.generate + 1 })
        setgenerate1(true)
    }
    return (
        <React.Fragment>
            <Head title="Main Report" />
            <Content>
                <Block>
                    <BlockHead size="lg">
                        <BlockDes className="text-soft">
                            <Row >
                                <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>DA Dashboard</h5>
                                    </td>
                                </Col>

                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 12 }}>  Center :  <label style={{ fontWeight: 'bold' }}><OptionL defaultValuemain={formData.year}  onInputChange={onInputChange} namemain="state" mainid="year" /></label></label>


                                </Col>
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 12 }}>  From :  <label style={{ fontWeight: 'bold' }}><OptionC defaultValuemain={formData.year} catid="42" onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                                </Col>
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 13 }}> To:  <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>


                                </Col>
                                <Col xl="3" md="3" >
                                    <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button>


                                </Col>

                            </Row>


                        </BlockDes>
                    </BlockHead>
                    <hr />
                    {generate1 ? <>

                        <Row>
                            <Col md="2" lg="3">

                            </Col>
                            <Col md="2" lg="3">

                            </Col>
                            <Col md="2" lg="3">

                            </Col>
                            <Col md="2" lg="3">
                                <DownloadTableExcel
                                    filename="Main Report"
                                    sheet="users"
                                    currentTableRef={tableRef.current}
                                >
                                    <Button style={{ float: "right", marginBottom: 10 }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                </DownloadTableExcel>
                            </Col>
                        </Row>
                        <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">

                            <table className="table table-orders" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                        <tr>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                Form: Main Report

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                From Date: {month1[formData.month]} {formData.year}

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                To Date: {month1[formData.tomonth]} {formData.toyear}

                                            </th>
                                        </tr>
                                    </thead>
                                </div>

                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>
                                    <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>

                                        </th>
                                        <th colSpan={states} style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                            PROGRESS REPORT OF NATIONAL CAREER SERVICE CENTRES FOR DIFFERENTLY ABLED
                                        </th>
                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                            Grand Total
                                        </th>
                                    </tr>


                                    <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                            DESCRIPTION
                                        </th>
                                        
                                            <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                                {states}

                                            </th>

                                        
                                    </tr>


                                </thead>

                               {/* <tr>



                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                        Live Register(LR) at the end of the month

                                    </th>




                                    <MainReportData Month={formData.tomonth} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.toyear} parametersId={171} />



                                    <MainReportTotal Month={formData.tomonth} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.toyear} parametersId={171} />
                                </tr >
                                <tr>



                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                        No. of trainees on roll at the end of month ( trade wise)

                                    </th>




                                    <MainReportData Month={formData.tomonth} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.toyear} parametersId={166} />



                                    <MainReportTotal Month={formData.tomonth} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.toyear} parametersId={166} />
                                </tr >

                                <tr>



                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                        No. of Camps Organised

                                    </th>



                                    <MainReportData Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={172} />



                                    <MainReportTotal Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={172} />
                                </tr >
                                <tr>



                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>
                                        Job Fairs

                                    </th>



                                    <MainReportData Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={218} />



                                    <MainReportTotal Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={218} />
                                </tr >
*/}
                                {userData.length > 0 ? <>
                                   


                                    <tr>



                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>

                                            No. of Job-seekers Participated

                                        </th>



                                        <ReportDataEmpParti Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} userId={formData.state} year={formData.year} emp={1} parametersId={218} />



                                        <MainReportTotal1 Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} emp={1} parametersId={218} />
                                    </tr >
                                    <tr>



                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>

                                            No. of  Employers Participated

                                        </th>



                                        <ReportDataEmpParti Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} emp={2} parametersId={218} />



                                        <MainReportTotal1 Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} emp={2} parametersId={218} />
                                    </tr >

                                    <tr>



                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth: 150 }}>

                                            No. of Candidates Shortlisted

                                        </th>



                                        <ReportDataEmpParti Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={218} />



                                        <MainReportTotal1 Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} parametersId={218} />
                                    </tr >
                                </>

                                    : < h5 > No Data</h5>}

                            </table>

                        </div>
                    </> : <h3>Please Select Month and Year to generate Report!!!</h3>

                    }


                </Block>




            </Content>

        </React.Fragment>
    );
};

export default Report1;
